import z from "zod";

import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/siders/search").GET();

const CompanySidersQuerySchema = endpoint.q.omit({ total: true });

export type CompanySidersQuery = z.infer<typeof CompanySidersQuerySchema>;
export async function getCompanySiders(
    { query }: { query: CompanySidersQuery },
    signal?: AbortSignal,
) {
    const call = createCall({ ...endpoint, q: CompanySidersQuerySchema }, (r) =>
        fetch(withAccountOrNetworkAuthHeaders(r)),
    );
    return await call({ query, signal });
}
